<template>
  <div style="display: inline-block" aria-live="assertive">
    <span v-if="showSuccess" style="position: absolute; left: -2000px"> Input is valid </span>
    <v-icon class="right-icon" v-show="showSuccess" color="success" :icon />
    <span v-if="showError" style="position: absolute; left: -2000px">Input is invalid</span>
    <v-icon class="right-icon" v-show="showError" color="error" :icon="mdiAlertCircleOutline" />
  </div>
</template>

<script lang="ts">
import { mdiAlertCircleOutline, mdiCheckCircleOutline } from '@mdi/js';
import { defineComponent, type ComponentOptions, type PropType } from 'vue';

const componentOptions: ComponentOptions = {
  props: {
    formField: {
      type: Object as PropType<{
        $dirty: boolean;
        $invalid: boolean;
        $model: { length: number };
        $error: boolean;
      }>,
      required: true,
    },
    icon: {
      type: String,
      required: false,
      default: mdiCheckCircleOutline,
    },
  },
  data: () => ({
    mdiAlertCircleOutline,
  }),
  computed: {
    showSuccess() {
      return this.formField.$dirty && !this.formField.$invalid && this.formField.$model.length > 0;
    },
    showError() {
      return this.formField.$error;
    },
  },
  name: 'FieldIcon',
};

export default defineComponent(componentOptions);
</script>
